import angular from "angular";
import UserService from "./UserService";
import FeatureService from "./FeatureService";
import ConfigService from "app/services/ConfigService";
import AuthenticationService from "./AuthenticationService";
import ContractService from "modules/dcb-eaccount/services/ContractService";
import toastr from "app/services/toastr";
import LocaleService from "app/services/LocaleService.js";
import lodash from "app/externals/lodash";
import BonusShopService from "./BonusShopService";

export default angular
  .module("services.MenuService", [
    UserService,
    FeatureService,
    ConfigService,
    AuthenticationService,
    ContractService,
    BonusShopService,
    toastr,
    LocaleService,
  ])
  .factory("MenuService", [
    "$q",
    "$rootScope",
    "UserService",
    "$state",
    "$window",
    "FeatureService",
    "ConfigService",
    "BonusShopService",
    "toastr",
    "LocaleService",
    "DialogService",
    "AuthenticationService",
    "ContractService",
    "$stateParams",
    "$timeout",
    "_",
    function MenuService(
      $q,
      $rootScope,
      UserService,
      $state,
      $window,
      FeatureService,
      ConfigService,
      BonusShopService,
      toastr,
      LocaleService,
      DialogService,
      AuthenticationService,
      ContractService,
      $stateParams,
      $timeout,
      _
    ) {
      var addCardMenu = {
        class: "main-submenu-item",
        current: "",
        icon: "",
        state: "addCard",
        activeStates: ["addCard"],
        feature: "menu.settings.cardDetails",
        description: "navbar.settings.addCard",
      };

      var normalMenus = [
        {
          class: "main-menu-item financial-overview",
          current: "",
          icon: getOverviewIcon(),
          description: "navbar.overview",
          state: "dashboard",
          feature: "menu.dashboard",
          subMenues: [],
        },
        {
          class: "main-menu-item my-cards",
          current: "",
          state: "cardList",
          href: true,
          icon: "fa fa-credit-card",
          description: "navbar.contracts",
          feature: "menu.contracts",
          collapsed: true,
          subMenues: [addCardMenu],
        },
        {
          class: "main-menu-item statements",
          current: "",
          state: "invoiceList",
          icon: "fa fa-align-left",
          description: "navbar.invoices",
          feature: "menu.invoices",
          subMenues: [],
        },
        {
          class: "main-menu-item sales",
          current: "",
          state: "transactionList",
          activeStates: ["transactionList", "transactionDetails"],
          icon: "fa fa-bar-chart",
          description: "navbar.transactions",
          feature: "menu.transactions",
          subMenues: [],
        },
        {
          class: "main-menu-item settings",
          current: "",
          href: "",
          icon: "fa fa-cog",
          description: "navbar.settings",
          feature: "menu.settings",
          collapsed: true,
          subMenues: [
            {
              class: "main-submenu-item",
              current: "",
              icon: "",
              state: "settingsProtectBuy",
              feature: "menu.settings.protectBuy",
              description: "navbar.settings.protectBuy",
            },
            {
              class: "main-submenu-item",
              current: "",
              icon: "",
              state: "settingsProfileOnly",
              feature: "menu.settings.profile",
              description: "navbar.settings.editprofile",
            },
            {
              class: "main-submenu-item",
              current: "",
              icon: "",
              state: "settingsChangePassword",
              feature: "menu.settings.profile",
              description: "navbar.settings.changePassword",
            },
            {
              class: "main-submenu-item",
              current: "",
              icon: "",
              state: "settingsSecurityQuestion",
              feature: "menu.settings.security",
              description: "navbar.settings.security",
            },
            {
              class: "main-submenu-item",
              current: "",
              icon: "",
              state: "settingsChangeEmail",
              feature: "menu.settings.changeEmail", // menu.settings.profile
              description: "navbar.settings.changeEmail",
            },
            {
              class: "main-submenu-item",
              current: "",
              icon: "",
              state: "settingsPhoneNumbers",
              feature: "menu.settings.phoneNumbers",
              description: "navbar.settings.phoneNumbers",
            },

            {
              class: "main-submenu-item",
              current: "",
              icon: "",
              state: "settingsPortletSettings",
              feature: "menu.settings.profile",
              description: "navbar.settings.portletSettings",
            },
            {
              class: "main-submenu-item",
              current: "",
              icon: "",
              state: "notificationList",
              executeUserCheck: UserService.canEditNotifications,
              feature: "menu.settings.notifications",
              description: "navbar.basicAgreements",
            },
            {
              class: "main-submenu-item",
              current: "",
              icon: "",
              state: "periodicDownloadList",
              feature: "menu.settings.periodicDownloads",
              description: "navbar.periodicDownload",
            },
          ],
        },
        {
          class: "main-menu-item administration",
          current: "",
          href: "",
          icon: "fa fa-cogs",
          description: "navbar.administration",
          feature: [
            "menu.administration",
            "menu.settings.users",
            "menu.settings.roles",
          ],
          collapsed: true,
          subMenues: [
            {
              class: "main-submenu-item",
              current: "",
              icon: "",
              state: "user",
              activeStates: ["user", "userEdit"],
              executeUserCheck: (user) => {
                return (
                  UserService.canEditUsers(user) &&
                  (FeatureService.hasFeatureInHash(
                    "menu.administration.users"
                  ) ||
                    FeatureService.hasFeatureInHash("menu.settings.users"))
                );
              },
              feature: ["menu.administration.users", "menu.settings.users"],
              description: "navbar.settings.useradministration",
            },
            {
              class: "main-submenu-item",
              current: "",
              icon: "",
              state: "roles",
              activeStates: ["roles", "rolesEdit"],
              executeUserCheck: (user) => {
                return (
                  UserService.canEditUsers(user) &&
                  (FeatureService.hasFeatureInHash(
                    "menu.administration.users"
                  ) ||
                    FeatureService.hasFeatureInHash("menu.settings.roles"))
                );
              },
              feature: ["menu.administration.users", "menu.settings.roles"],
              description: "navbar.settings.editroles",
            },
            {
              class: "main-submenu-item",
              current: "",
              icon: "",
              state: "activities",
              feature: "menu.administration",
              //feature: "menu.administration.activities",
              description: "navbar.administration.activities",
            },
            {
              class: "main-submenu-item",
              current: "",
              icon: "",
              state: "eMails",
              feature: "menu.administration",
              //feature: "menu.administration.eMails",
              description: "navbar.administration.eMails",
            },
            {
              class: "main-submenu-item",
              current: "",
              icon: "",
              state: "knowYourCustomerAdmin",
              executeUserCheck: (user) =>
                UserService.canSeeKYC(user) &&
                FeatureService.hasFeatureInHash("menu.administration.kyc"),
              feature: "menu.administration.kyc",
              description: "navbar.administration.kyc",
            },
          ],
        },
        {
          class: "main-menu-item messages",
          current: "",
          href: "",
          icon: "fa fa-envelope",
          description: "navbar.messages",
          state: "messageDetails",
          feature: "menu.messages",
          collapsed: true,
          subMenues: [
            {
              class: "main-submenu-item",
              current: "",
              state: "messageInbox",
              activeStates: ["messageInbox", "inmessage"],
              icon: "",
              feature: "menu.messages.inbox",
              description: "navbar.messages.inbox",
            },
            {
              class: "main-submenu-item",
              current: "",
              state: "messageOutbox",
              activeStates: ["messageOutbox", "outmessage"],
              icon: "",
              feature: "menu.messages.outbox",
              description: "navbar.messages.outbox",
            },
            {
              class: "main-submenu-item",
              current: "",
              state: "messageNew",
              activeStates: ["messageReply", "messageComplain", "messageNew"],
              icon: "",
              feature: "menu.messages.newMessage",
              description: "navbar.messages.newmessage",
            },
          ],
        },
        {
          class: "main-menu-item currency",
          current: "",
          state: "exchangeRateList",
          icon: "fa fa-calculator",
          feature: "menu.exchangeRates",
          description: "navbar.currencyconverter",
          subMenues: [],
        },
        {
          class: "main-menu-item bonusShop",
          current: "",
          url: "",
          icon: "fa fa-external-link",
          feature: "menu.bonusShop",
          description: "navbar.bonusShop",
          subMenues: [],
        },
        {
          class: "main-menu-item currency",
          current: "",
          state: "test",
          icon: "fa fa-rocket",
          feature: "menu.test",
          description: "navbar.test",
          subMenues: [],
        },
      ];

      var loginMenus = [
        {
          class: "main-menu-item",
          current: "",
          icon: "fa fa-pencil-square-o",
          description: "navbar.register",
          configValue: "loginMenus.register",
          state: "signup",
          activeStates: [
            "signup",
            "signupDone",
            "signupComplete",
            "confirmIdentity",
            "register",
            "protectBuy",
            "knowYourCustomer",
            "knowYourCustomerCompleted",
          ],
          subMenues: [],
        },
        {
          class: "main-menu-item",
          current: "",
          icon: "fa fa-sign-in",
          description: "navbar.login",
          state: "login",
          subMenues: [],
        },
        {
          class: "main-menu-item",
          current: "",
          icon: "fa fa-lock",
          description: "navbar.forgotPassword",
          state: "forgotPassword",
          subMenues: [],
        },
        {
          class: "main-menu-item",
          current: "",
          icon: "fa fa-at",
          description: "navbar.forgotEmail",
          configValue: "loginMenus.forgotEmail",
          state: "forgotEmail",
          subMenues: [],
        },
        {
          class: "main-menu-item currency",
          current: "",
          icon: "fa fa-calculator",
          description: "navbar.currencyconverter",
          configValue: "loginMenus.currencyconverter",
          state: "anonymousExchangeRates",
          subMenues: [],
        },
        {
          class: "main-menu-item",
          current: "",
          url: ConfigService.get("links.termsAndConditions", true),
          icon: "fa fa-external-link",
          description: "navbar.agb",
        },
        {
          class: "main-menu-item",
          current: "",
          url: ConfigService.get("links.cookiePolicyUrl", true),
          icon: "fa fa-external-link",
          description: "navbar.privacyPolicy",
        },
        {
          class: "main-menu-item",
          current: "",
          icon: "fa fa-external-link",
          description: "navbar.cookies",
          state: "cookieSettings",
        },
        {
          class: "main-menu-item",
          current: "",
          url: ConfigService.get("links.impressum", true),
          icon: "fa fa-external-link",
          description: "navbar.about",
        },
        {
          class: "main-menu-item",
          current: "",
          url: ConfigService.get("links.history", true),
          icon: "fa fa-external-link",
          description: "navbar.history",
          feature: "menu.invisible",
        },
        {
          class: "main-menu-item",
          current: "",
          url: ConfigService.get("links.frequentlyAskedQuestions", true),
          icon: "fa fa-external-link",
          description: "navbar.faq",
        },
        /*{
         class: "main-menu-item",
         current: "",
         href: "#/faq",
         icon: "fa fa-question",
         description: "navbar.faq",
         state : "faq",
         subMenues: []
         }*/
      ];

      var demoLink = ConfigService.get("links.demoFrontend", true);

      if (demoLink) {
        loginMenus.push({
          class: "main-menu-item",
          current: "",
          url: demoLink, // "http://usvapp2t.airplus.at:5555/#/de/demologin", // ConfigService.get("links.demoFrontend", true)
          icon: "fa fa-eye",
          description: "navbar.demoUser",
        });
      }

      var serviceMenu = {
        class: "main-menu-item service",
        current: "",
        href: "",
        icon: "fa fa-question-circle",
        description: "navbar.service",
        collapsed: true,
        subMenues: [
          {
            class: "main-submenu-item",
            current: "",
            url: ConfigService.get("links.airportLounges", true),
            icon: "fa fa-external-link",
            description: "navbar.service.airportlounges",
          },
          {
            class: "main-submenu-item",
            current: "",
            url: ConfigService.get("links.frequentlyAskedQuestions", true),
            icon: "fa fa-external-link",
            description: "navbar.service.faq",
          },
          {
            class: "main-submenu-item",
            current: "",
            url: ConfigService.get("links.termsAndConditions", true),
            icon: "fa fa-external-link",
            description: "navbar.service.agb",
          },
          {
            class: "main-submenu-item",
            current: "",
            url: ConfigService.get("links.impressum", true),
            icon: "fa fa-external-link",
            description: "navbar.service.about",
          },
          {
            class: "main-submenu-item",
            current: "",
            url: ConfigService.get("links.history", true),
            icon: "fa fa-external-link",
            description: "navbar.service.history",
            feature: "menu.invisible",
          },
        ],
      };

      //loginMenus.push(serviceMenu);
      normalMenus.push(serviceMenu);

      var menus = normalMenus;
      var contractMenuInit = false;
      var activeMenu = "login";
      var sidebarCollapsed = false;
      var cards;

      function setCardMenuItems() {
        contractMenuInit = true;
        var cardMenu = [];
        FeatureService.hasFeature("menu.settings.cardDetails").then(function (
          hasFeature
        ) {
          if (hasFeature) {
            ContractService.getCards(undefined, undefined, true).then(
              (data) => {
                for (var i = 0; i < data.length; i++) {
                  cardMenu.push({ name: data[i].cardNr, id: data[i].id });
                }
                addToMenu("cardList", "cardDetails", cardMenu);
              }
            );
          } else {
            addToMenu("cardList", "cardDetails", undefined);
          }
        });

        fixDashboardIcon();
      }

      function getOverviewIcon() {
        if (FeatureService.hasFeatureInHash("menu.dashboard.home")) {
          return "fa fa-home";
        } else {
          return "fa fa-euro";
        }
      }

      function fixDashboardIcon() {
        let menu = findMenuByState("dashboard");
        if (menu.icon !== getOverviewIcon()) {
          menu.icon = getOverviewIcon();
        }
      }

      function clearMenu() {
        menus = normalMenus;
        contractMenuInit = false;
        // CardMenu could be changed
      }

      function getMenus() {
        if ($state.current.data && $state.current.data.showLoginClass) {
          if (contractMenuInit) {
            clearMenu();
          }
          return loginMenus;
        } else {
          if (!contractMenuInit) {
            //if (FeatureService.hasFeature("menu.settings.cardDetails")) {
            setCardMenuItems();
            //}
          }
          return normalMenus;
        }
      }

      function hasVisibleSubmenu(menu) {
        if (menu.subMenues && menu.subMenues.length > 0) {
          for (var i = 0; i < menu.subMenues.length; i++) {
            if (isMenuVisible(menu.subMenues[i])) {
              return true;
            }
          }
          return false;
        } else {
          return true;
        }
      }

      function isMenuVisible(menu) {
        return (
          FeatureService.hasFeatureInHash(menu.feature) &&
          passUserCheck(menu) &&
          hasVisibleSubmenu(menu) &&
          ConfigService.get(menu.configValue, true, true)
        );
      }

      function shouldShowMenu(menu) {
        var defer = $q.defer();

        if (menu.feature) {
          FeatureService.hasFeature(menu.feature).then(function (hasFeature) {
            defer.resolve(hasFeature);
          });
        } else {
          defer.resolve(true);
        }

        return defer.promise;
      }

      function getActiveMenu() {
        return activeMenu;
      }

      function isMenuStateActive(menu) {
        var state = [];

        if (menu.activeStates) {
          state = state.concat(menu.activeStates);
          if (!(menu.state === "cardDetails")) {
            state.push(menu.state);
          }
        } else {
          state = menu.state;
        }
        if (angular.isArray(state)) {
          for (var j = 0; j < state.length; j++) {
            if ($state.params.id === state[j]) {
              return true;
            }
            if ($state.is(state[j])) {
              return true;
            }
          }
        } else {
          if ($state.is(state)) {
            return true;
          }
        }
        return false;
      }

      function isActive(menu) {
        var active = false;
        if (menu.subMenues && menu.subMenues.length > 0) {
          for (var i = 0; i < menu.subMenues.length; i++) {
            if (isMenuStateActive(menu.subMenues[i])) {
              active = true;
              //menu.collapsed = false;
            }
          }
          if (!active) {
            active = isMenuStateActive(menu);
          }
        } else {
          active = isMenuStateActive(menu);
        }
        return active;
      }

      function resetSubMenues(subMenues) {
        return subMenues.filter((item) => {
          return !item.stateID;
        });
      }

      function addToMenu(identifier, menuState, subMenues) {
        var menu = findMenuByState(identifier);
        var activeState;

        if (menu) {
          if (subMenues) {
            if (!menu.subMenues) {
              menu.subMenues = [addCardMenu];
            }
            menu.subMenues = resetSubMenues(menu.subMenues);
            for (var i = 0; i < subMenues.length; i++) {
              activeState = subMenues[i].id.toString();
              if (!menuState) {
                menuState = identifier;
              }
              menu.subMenues.push({
                class: "main-submenu-item",
                current: "",
                icon: "",
                state: menuState,
                activeStates: [activeState],
                feature: "",
                description: subMenues[i].name,
                stateID: subMenues[i].id,
              });
            }
            menu.subMenues = _.sortBy(menu.subMenues, "description");
          } else {
            menu.subMenues = undefined;
          }
        }
      }

      function findMenuByState(state) {
        for (var i = 0; i < menus.length; i++) {
          if (menus[i].state === state) {
            return menus[i];
          }

          if (menus[i].subMenues) {
            var subMenues = menus[i].subMenues;
            for (var j = 0; j < subMenues.length; j++) {
              if (subMenues[j].state === state) {
                return subMenues[j];
              }
            }
          }
        }
        return undefined;
      }

      function toggle(menu) {
        collapseOthers(menu);
        menu.collapsed = !menu.collapsed;
      }

      function go(menu) {
        if (menu.description == "navbar.bonusShop") {
          try {
            if (cards.length == 1) {
              let redirectWindow = window.open("about:blank", "_blank");
              BonusShopService.shopLogin(cards[0])
                .then((response) => {
                  if (response.redirect_url_fragment == undefined) {
                    throw new Error();
                  }
                  redirectWindow.location.href = response.redirect_url_fragment;
                })
                .catch((err) => {
                  toastr.error(LocaleService.get("bonusshop.error"));
                  redirectWindow.close();
                });
            }

            if (cards.length > 1) {
              DialogService.showBonusShopDialog(undefined);
            }
          } catch (err) {
            toastr.error(LocaleService.get("bonusshop.error"));
          }
        } else {
          if (menu.state) {
            collapseOthers(menu);
            activeMenu = menu.state;
            var menuParam = {};
            if (menu.stateID > 0) {
              menuParam.id = menu.stateID;
            }
            $state.go(menu.state, menuParam, { reload: true });
          }
          if (menu.url) {
            $window.open(menu.url, "_blank");
          }
        }
        if (menu.exec) {
          // if a menu should execute some js code just add an exec option to the option
          menu.exec();
        }
      }
      function initBonusshop() {
        BonusShopService.getBonusshopContracts().then((result) => {
          cards = result;
        });
      }

      function goToState(state, params) {
        var menu = findMenuByState(state);
        if (menu) {
          collapseOthers(menu);
        }

        if (params) {
          $timeout(() => {
            $state.go(state, params);
          });
        } else {
          $timeout(() => {
            $state.go(state);
          });
        }
      }

      function collapseOthers(menu) {
        var doCollapse = false;
        for (var i = 0; i < menus.length; i++) {
          if (menu.description !== menus[i].description) {
            doCollapse = true;
            if (menus[i].subMenues) {
              for (var j = 0; j < menus[i].subMenues.length; j++) {
                if (menus[i].subMenues[j].description === menu.description) {
                  doCollapse = false;
                }
              }
              menus[i].collapsed = doCollapse;
            }
          }
        }
      }

      function collapseSidebar() {
        sidebarCollapsed = !sidebarCollapsed;
      }

      function passUserCheck(menu) {
        if (
          menu.executeUserCheck !== undefined &&
          _.isFunction(menu.executeUserCheck)
        ) {
          return menu.executeUserCheck(AuthenticationService.getUserSync());
        } else {
          return true;
        }
      }

      function reload(ignoreParams) {
        $timeout(() => {
          //$state.go(".",{},{notify : false,reload:true});
          //$state.reload();

          $state.transitionTo(
            $state.current,
            ignoreParams ? {} : $state.$current.params,
            { reload: true, inherit: true, notify: true }
          );
        });
      }

      function isOpen(menu) {
        var open = !menu.collapsed;
        if (menu.subMenues && menu.subMenues.length > 0) {
          for (var i = 0; i < menu.subMenues.length; i++) {
            if (isMenuStateActive(menu.subMenues[i])) {
              open = true;
              //menu.collapsed = false;
            }
          }
        }
        return open;
      }

      return {
        reload: reload,
        getMenus: getMenus,
        //setMenus: setMenus,
        isActive: isActive,
        collapseOthers: collapseOthers,
        go: go,
        goToState: goToState,
        getActiveMenu: getActiveMenu,
        loginMenus: loginMenus,
        normalMenus: normalMenus,
        sidebarCollapsed: sidebarCollapsed,
        collapseSidebar: collapseSidebar,
        shouldShowMenu: shouldShowMenu,
        findMenuByState: findMenuByState,
        addToMenu: addToMenu,
        toggle: toggle,
        isOpen: isOpen,
        isMenuVisible: isMenuVisible,
        passUserCheck: passUserCheck,
        clearMenu: clearMenu,
        initBonusshop: initBonusshop,
      };
    },
  ]).name;



// WEBPACK FOOTER //
// ./src/ui/modules/dcb-eaccount/services/MenuService.js